import { render, staticRenderFns } from "./HomeGameElement.vue?vue&type=template&id=361778c4&scoped=true"
import script from "./HomeGameElement.vue?vue&type=script&lang=js"
export * from "./HomeGameElement.vue?vue&type=script&lang=js"
import style0 from "./HomeGameElement.vue?vue&type=style&index=0&id=361778c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361778c4",
  null
  
)

export default component.exports